<template>
  <div>
    <div class="cert" @click="showTagsPop">
      <div class="cert_content">
        <ul class="cert_logo">
          <li>
            <i></i>
            <span>平台认证</span>
          </li>
        </ul>
        <ul class="cert_title">
          <li v-if="backTone">身份认证</li>
          <li v-else>背景调查认证</li>
          <li>·</li>
          <li>健康认证</li>
          <li>·</li>
          <li>技能证书认证</li>
        </ul>
      </div>
      <div class="cert_more">
        <img src="../../../../assets/images/certification_more@3x.png" alt="" />
      </div>
    </div>
    <popup v-model="popStatus" @closed="handleClosed" :lazyRender="false">
      <div class="certification">
        <div class="header">
          认证说明
          <i class="icon_close" @click="handleClosed"></i>
        </div>
        <div class="content">
          <ul>
            <li class="content_items" v-if="backTone">
              <div class="item">
                <i class="iconOK"></i><span>身份认证</span>
              </div>
              <p class="text">
                对服务人员身份证基础信息、头像、证件有效期进行核查
              </p>
            </li>
            <li class="content_items" v-else>
              <div class="item">
                <i class="iconOK"></i><span>背景调查认证</span>
              </div>
              <p class="text">
                该服务人员已通过专业公司背景调查，无任何违法行为和信用风险
              </p>
            </li>
            <li class="content_items">
              <div class="item">
                <i class="iconOK"></i><span>健康证认证</span>
              </div>
              <p class="text">对持证人基础信息，核查健康证有效期进行核查</p>
            </li>
            <li class="content_items">
              <div class="item">
                <i class="iconOK"></i><span>技能证书认证</span>
              </div>
              <p class="text">
                所有服务人员均持有国家/地方人社部颁发育婴员/母婴护理师证书
              </p>
            </li>
          </ul>
        </div>
        <div class="btn">
          <div class="btn_red" @click="handleClosed">确定</div>
        </div>
      </div>
    </popup>
  </div>
</template>
<script>
import popup from '@/components/action-sheet/popup'
export default {
  data() {
    return {
      popStatus: false
    }
  },
  props: {
    backTone: Number
  },
  components: {
    popup
  },
  methods: {
    showTagsPop() {
      this.popStatus = true
    },
    handleClosed() {
      this.popStatus = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/css/mixin';
.cert {
  // background-image: url('../../../../assets/images/certification_bg@3x.png');
  background-image: url('../../../../assets/images/certification_bg_noshadow@3x.png');
  background-size: rem(688px) rem(78px);
  border-radius: 0 0 rem(16px) rem(16px);
  display: flex;
  height: rem(78px);
  line-height: rem(98px);

  .cert_more {
    width: rem(47px);
    img {
      position: absolute;
      overflow: hidden;
      right: rem(17px);
      bottom: rem(20px);
      width: rem(20px);
      height: rem(20px);
    }
  }
}

.cert_content {
  display: flex;
  flex: 1;
  justify-content: space-between;
}

.cert_logo {
  font-family: PingFangSC-Medium;
  font-size: rem(26px);
  color: #f4cbaf;
  font-weight: 500;
  > li {
    display: flex;
    align-items: center;

    i {
      background-image: url('../../../../assets/images/certification_logo@3x.png');
      background-size: rem(24px) rem(26px);
      background-position: fixed top;
      display: inline-block;
      width: rem(24px);
      height: rem(26px);
      margin: 0 rem(8px) 0 rem(17px);
    }
  }
}

.cert_title {
  height: rem(56px);
  display: flex;
  justify-content: space-between;
  font-size: rem(24px);
  color: #f4cbaf;
  li {
    display: flex;
    &:nth-child(2n) {
      margin: 0 rem(10px);
    }
  }
  & i {
    width: rem(26px);
    height: rem(26px);
    display: inline-block;
    background: url('https://hzwimspic-1251601690.image.myqcloud.com/b703f6e0-7d53-11eb-955e-df4b593726f9_size_45x45')
      no-repeat center center;
    background-size: rem(26px) rem(26px);
    margin-right: rem(8px);
  }
}

.yuesao_tags {
  display: flex;
  margin: 0 rem(24px);
  width: rem(702px);
  height: rem(56px);
}
.certification {
  max-width: rem(750px);
  margin: 0 auto;
  .header {
    font-size: rem(32px);
    color: #262626;
    line-height: rem(40px);
    padding-left: rem(24px);
    //  text-align: center;
    margin: rem(48px) 0 rem(40px);
    font-weight: 500;

    .icon_close {
      width: rem(40px);
      height: rem(40px);
      position: absolute;
      overflow: hidden;
      right: rem(24px);
      top: rem(46px);
      background: url('https://hzwimspic-1251601690.image.myqcloud.com/d7708d40-7d52-11eb-955e-df4b593726f9_size_60x60')
        no-repeat center center;
      background-size: rem(40px) rem(40px);
    }
  }
  .content {
    height: rem(600px);
    overflow: auto;

    .content_items {
      margin-bottom: rem(48px);
    }
    .item {
      font-size: rem(28px);
      font-size: 500;
      color: #262626;
      // color: #ff397e;
      line-height: rem(34px);
      margin-bottom: rem(16px);
      display: flex;
      // justify-content: flex-start;

      .iconOK {
        display: inline-block;
        width: rem(32px);
        height: rem(32px);
        background: url('https://hzwimspic-1251601690.image.myqcloud.com/b703f6e0-7d53-11eb-955e-df4b593726f9_size_45x45')
          no-repeat center center;
        background-size: rem(30px) rem(30px);
        margin: rem(2px) rem(20px) 0;
      }
    }
    .text {
      margin: 0 rem(24px) 0 rem(75px);
      font-size: rem(24px);
      color: #666666;
      line-height: rem(36px);
    }
  }
  .btn {
    height: rem(100px);
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn_red {
      background-image: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
      border-radius: rem(44px);
      width: rem(718px);
      height: rem(80px);
      font-size: rem(32px);
      color: #ffffff;
      text-align: center;
      line-height: rem(80px);
    }
  }
}
</style>
